import React, { Component } from 'react'
import cubeApiClient from '../BusinessObjects/cubeApiService';
import { RouteComponentProps, Route, Redirect } from 'react-router';
import { Link } from 'react-router-dom';

import LoggedContext from '../BusinessObjects/LoggedContext'
import Companies from '../Models/Companies';
import UserProfile from '../Models/UserProfile';

interface UserCompanyListState {
    companies: Companies[];
    loading: boolean;
    errorMessage:string;
    companychanged: boolean;
}

export default class UserCompanyList extends Component<RouteComponentProps<{}>, UserCompanyListState> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>

    constructor(props:RouteComponentProps<{}>) {
        super(props);

        this.state = {
            companies: [],
            loading: true,
            errorMessage: '',
            companychanged: false
        }
    }

    handleChange = (e:any) => {
        var cmp=this.state.companies[e.target.max];
        var up:UserProfile =this.context.userProfile;
        
         
        
        up.CompanyName = cmp.CompanyName;
        up.ERPCompanyCode=cmp.ERPCompanyCode
        up.customer_ID=cmp.customer_ID;

        /// Aggiorno il portale
        const service = new cubeApiClient();
        service
            .changeUserProfile(up,this.context.tokenAPI)
            .then((data: any) => {

                this.context.setUserProfile(up);
                this.setState({companychanged:true});
                        
            },
            (error: any) => {
                alert('ERRORREEEE!!'  + error);
            }); 

      }
      
    componentDidMount() {
        const service = new cubeApiClient();
        const t = this.context.tokenAPI;
        
        service
            .getItems('api/sys/UserCompanies',t)
            .then((data: any) => {
                this.setState({ companies: data, loading: false });
            },
            (error: any) => {
                this.setState({ companies: [], loading: false, errorMessage: error });
            });
    }

    render() {
        const { companies, companychanged } = this.state;

        if(companychanged)
            return <Redirect to='/home'></Redirect>
        else
        {

        let ticketData = companies.map((item: Companies,index) => (
            <tr key={index}>
                {/* <td>{new Date(item.issueDate).toISOString().slice(0,10)}</td> */}
                <td>
                <input type="button" className="btn btn-outline-info btn-sm" max={index}  value="Seleziona" onClick={this.handleChange} />                    
                </td>
                <td>{item.customer_ID}</td>
                <td>{item.CompanyName}</td>
            </tr>
        ));

        let contents = this.state.loading
            ? <tr><td colSpan={6} style={{"textAlign":"center"}}><span>Loading...</span></td></tr>
            : ticketData;

        return (
        <div className="container">
            <div className="row">
                <div className="col-xl-12">&nbsp;</div>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>ID</th>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contents}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        )
        }
    }
}
